import React, { useState } from 'react';
import ImpersonateModal from 'legacy/src/components/impersonating/components/ImpersonateModal';

export default (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [otherProps, setOtherProps] = useState({});
  const { modal: Component = ImpersonateModal, ...rest } = props || {};
  const onClose = () => {
    setIsOpen(false);
  };

  const modal = isOpen ? (
    <Component onClose={onClose} {...rest} {...otherProps} />
  ) : null;
  const onOpenModal = (p = {}) => {
    setOtherProps(p);
    setIsOpen(true);
  };
  return [modal, onOpenModal];
};
